export default __webpack_public_path__ + "static/media/xtimeMob.45ba0b3c.png";